import React from 'react'
import { ResidentAppNotifications } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { DataLoader } from './ResidentNotificationsDataLoader'
import { ErrorHandler } from './ResidentNotificationsErrorHandler'
import {
  ContractType,
  ResidentNotificationCategory,
} from '../../../common/types'
import ResidentNotification from '../ResidentNotification'
import { isNotificationShown } from '../ResidentNotification/utils'

import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

interface ResidentNotificationsProps {
  categories?: ResidentNotificationCategory[]
  className?: string
  contractType?: ContractType
}

export const ResidentNotifications: React.FC<ResidentNotificationsProps> = ({
  categories,
  className,
  contractType,
}) => {
  const { t } = useTranslation(['notifications'])
  const { messaging } = useModuleConfig()

  return (
    <ErrorHandler>
      <DataLoader notificationCategories={categories}>
        {({ notifications, userMetadata }) => (
          <ResidentAppNotifications
            aria-label={t('notifications:label')}
            className={className}
          >
            {notifications
              .filter((notification) =>
                isNotificationShown(notification, messaging)
              )
              .map((notification) => (
                <ResidentNotification
                  key={notification.id}
                  notification={notification}
                  userMetadata={userMetadata}
                  contractType={contractType}
                />
              ))}
          </ResidentAppNotifications>
        )}
      </DataLoader>
    </ErrorHandler>
  )
}
